import { Component, computed, inject, Signal } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MatDialogClose } from "@angular/material/dialog";
import { AuthService } from '../../../services/auth.service';
import { RouterLink } from '@angular/router';
import { AccountDto } from '../../../../api/models/fraud.models';
import { TelegramIdentifyService } from '../../../services/telegram-identify.service';
import { DialogService } from '../../../services/dialog.service';
import { AccountAccessService } from '../../../services/account-access.service';
import { ProjectSettingsService } from '../../../services/project-settings.service';

@Component({
  selector: 'app-dialog-nav-menu',
  imports: [
    MatIcon,
    MatDialogClose,
    RouterLink
  ],
  templateUrl: './dialog-nav-menu.html',
  styleUrl: './dialog-nav-menu.scss'
})
export class DialogNavMenu {
  private readonly _dialogService: DialogService = inject(DialogService);
  public readonly authService: AuthService = inject(AuthService);
  protected readonly accountAccessService: AccountAccessService = inject(AccountAccessService);
  private readonly _projectSettingsService: ProjectSettingsService = inject(ProjectSettingsService);

  public readonly telegramIdentifyService: TelegramIdentifyService = inject(TelegramIdentifyService);

  readonly isAmlEnergyActive: Signal<boolean> = computed(() => this._projectSettingsService.settings()?.isAmlEnergyActive ?? false);

  readonly isShowAddWallet: Signal<boolean> = computed(() => {
    const user: AccountDto | undefined = this.authService.accountDto();
    if (!user || !this.isAmlEnergyActive()) return false;
    return Boolean(user.plan) || user.countOfAmlEnergyWallets === 0;
  })

  readonly isButtonWalletCheck: Signal<boolean> = computed(() => {
    const user: AccountDto | undefined = this.authService.accountDto();
    if (!user) return false;
    return user.isWalletCheckEnabled;
  })

  readonly isBusinessAccount: Signal<boolean> = computed(() => {
    const accounts: AccountDto[] | undefined = this.authService.accounts();
    if (!accounts || accounts.length === 0) return false;
    return Boolean(accounts.find(account => account.accountType === 'CORPORATE'));
  })
  
  readonly isDeniedForViewer: Signal<boolean> = computed(() => {
    const user: AccountDto | undefined = this.authService.accountDto();
    if (!user) return false;
    return user.accountType === 'CORPORATE' && user.companyRole === 'VIEWER';
  })
  
  readonly isPoliceAccount: Signal<boolean> = computed(() => {
    const user: AccountDto | undefined = this.authService.accountDto();
    if (!user) return false;
    return user.accountType === 'CORPORATE' && user.role === 'POLICE';
  })

  openDesktopBenefitsDialog(): void {
    this._dialogService.openDesktopBenefitsDialog().afterClosed().subscribe(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  }

  openRegisterBusinessAccountDialog(): void {
    this._dialogService.openBenefitBusinessAccountDialog().afterClosed().subscribe(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  }

  handleContactSupport(): void {
    this.telegramIdentifyService.handleSupportAction();
  }
}
